import { render, staticRenderFns } from "./widget-nota_quero.vue?vue&type=template&id=69b48137&scoped=true"
import script from "./widget-nota_quero.vue?vue&type=script&lang=js"
export * from "./widget-nota_quero.vue?vue&type=script&lang=js"
import style0 from "./widget-nota_quero.vue?vue&type=style&index=0&id=69b48137&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b48137",
  null
  
)

export default component.exports